import React from "react";
import { Button } from "primereact/button";

const PaginationControls = ({
  currentYear,
  currentMonth,
  goToPreviousMonth,
  goToNextMonth,
  isCurrentMonth,
  loading,
}) => {
  const monthLabel = new Date(currentYear, currentMonth - 1).toLocaleString(
    "default",
    { month: "long", year: "numeric" }
  );

  return (
    <div className="flex align-items-center justify-content-between gap-3">
      <Button
        label="Previous"
        icon="pi pi-angle-left"
        iconPos="left"
        onClick={goToPreviousMonth}
        outlined
        severity="secondary"
        disabled={loading}
      />
      <span className="font-semibold text-700 text-lg">{monthLabel}</span>
      <Button
        label="Next"
        icon="pi pi-angle-right"
        iconPos="right"
        onClick={goToNextMonth}
        outlined
        severity="secondary"
        disabled={isCurrentMonth || loading}
      />
    </div>
  );
};

export default PaginationControls;
